import { TFunction } from 'i18next';
import * as yup from 'yup';

type OrderValidationSchemaOptions = {
  isOneOfVoucherIntents: boolean;
  contactOptional: boolean;
};

export const buildOrderValidationSchema = (
  t: TFunction,
  { isOneOfVoucherIntents, contactOptional }: OrderValidationSchemaOptions,
) => {
  const isContactOptional = contactOptional && !isOneOfVoucherIntents;
  const emailValidation =
    isOneOfVoucherIntents || isContactOptional
      ? yup
          .string()
          .optional()
          .test('is-valid-emails', t('order_page.email_valid'), (value) => {
            if (!value) return true;
            const emails = value.split(',').map((e) => e.trim());
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emails.every((e) => emailRegex.test(e));
          })
      : yup
          .string()
          .test('is-valid-emails', t('order_page.email_valid'), (value) => {
            if (!value) return false;
            const emails = value.split(',').map((e) => e.trim());
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emails.every((e) => emailRegex.test(e));
          })
          .required(t('order_page.email_required'));

  return yup.object().shape({
    firstname: yup.string().required(t('order_page.firstname_required')),
    lastname: isOneOfVoucherIntents
      ? yup.string().optional()
      : yup.string().required(t('order_page.lastname_required')),
    email: emailValidation,
    phone: isContactOptional
      ? yup.string().test('min-when-set', t('order_page.phone_valid'), (value) => !value || value.length >= 10)
      : yup.string().min(10, t('order_page.phone_valid')).required(t('order_page.phone_required')),
    voucher_greeting_message: yup.string().optional(),
    should_send_to_recipient: yup.boolean().optional(),
    recipient_email: yup.string().when('should_send_to_recipient', {
      is: true,
      then: yup.string().email(t('order_page.email_valid')).required(t('order_page.email_required')),
      otherwise: yup.string().email(t('order_page.email_valid')).optional(),
    }),
  });
};
